<template>
    <div class="top-nav-menu-wrap" :class="{ 'sidebar-collapsed': sidebarCollapse }">
        <div class="header admin-header site-top">
            <div class="site-top-inner">
                <a v-on:click="changeSidebarState" class="nav-link" data-widget="pushmenu" href="#" role="button"><i
                        class="fa fa-bars"></i></a>
            </div>
            <!-- Trial Mode -->
            <!-- <div v-if="adminDetails.web_trial == true && $route.path != '/app/subscription-payments'"
                class="trial-mode-notice">
                <div class="trial-mode-text">
                    Your account is in trial mode. Go to
                    <span class="trial-subscribe"><router-link :to="{ path: '/app/subscription-payments' }">Subscription
                            & Payments</router-link></span>
                    to activate your subscription.
                </div>
            </div> -->
            <!-- Trial Mode Expired -->
            <div class="trial-mode-notice">
                <div class="trial-mode-text" v-if="adminDetails.web_trial_expired == true">
                    <span class="trial-subscribe">
                        Your trial has expired. Go to
                        <router-link :to="{ path: '/app/subscription-payments' }">Subscription & Payments</router-link>
                        to activate your subscription.
                    </span>
                </div>
                <div v-if="adminDetails.subscription" class="is-subscription-expired">
                    <div v-if="isSubscriptionExpired" class="trial-mode-text">
                        <span class="trial-subscribe">
                            Your subscription has expired. Go to
                            <router-link :to="{ path: '/app/subscription-payments' }">Subscription &
                                Payments</router-link>
                            to activate your subscription.
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="adminDetails.active == 2">
            <div class="team-group-invite-container">
                <div class="pending-group-request">
                    {{ $t("general.pendingGroupRequest") }} "{{ adminDetails.group_name }}"
                </div>
                <div class="group-invite-btns">
                    <div>
                        <button class="primary-btn extra-small" v-on:click="acceptInvite(true)">Accept</button>
                    </div>
                    <div>
                        <button class="secondary-btn small" v-on:click="acceptInvite(false)">Decline</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="
            adminDetails.sorted_payments_list &&
            adminDetails.sorted_payments_list.length > 0 &&
            adminDetails.sorted_payments_list[0]['event_type'] &&
            adminDetails.sorted_payments_list[0]['event_type'] == 'subscription_charged_unsuccessfully'
        " class="text-center">
            <div class="col-12 subscription-charge-issue-notice">
                !Subscription charged unsuccessfully. Please Add New Card and restart your subscription!
            </div>
        </div>
        <!-- <div class="download-app-container" v-if="generalOptions.app_id === 1">
            <p>
                For a better experience feel free to download our app from<a
                    href="https://apps.apple.com/us/app/ring-my-stylist-booking-app/id1250537446"
                >
                    Apple Store</a
                >
                or<a href="https://play.google.com/store/apps/details?id=com.ringmystylist.app"> Google Play </a>
                !
            </p>
        </div>
        <div class="download-app-container" v-if="generalOptions.app_id === 2">
            <p>
                For a better experience feel free to download our app from<a
                    href="https://apps.apple.com/us/app/ring-my-barber-booking-app/id1451800946"
                >
                    Apple Store</a
                >
                or<a href="https://play.google.com/store/apps/details?id=com.ringmystylist.app.rmb"> Google Play </a>
                !
            </p>
        </div>
        <div class="download-app-container" v-if="generalOptions.app_id === 5">
            <p>
                For a better experience feel free to download our app from<a
                    href="https://apps.apple.com/us/app/ring-my-loctician-booking-app/id1558673025"
                >
                    Apple Store</a
                >
                or<a href="https://play.google.com/store/apps/details?id=com.ringmystylist.app.rml"> Google Play </a>
                !
            </p>
        </div> -->
    </div>
</template>

<script>
import auth from "../../services/auth.js";
import api from "../../services/apiEndpoints.js";
import $ from "jquery";
import moment from "moment";
import eventBus from "../../services/eventBus.js";
import store from "../../services/vuex.js";

export default {
    name: "AdminHeader",
    data() {
        return {
            user: null,
            isStylist: false,
            showTeam: false,
            sidebarCollapse: true,
        };
    },
    mounted() {
        // Initialize user from auth state
        this.user = auth.state.user;
        this.checkStylist();
        this.initUserDetails();

        // Listen for user profile updates
        eventBus.on("user_profile_loaded", () => {
            this.user = auth.state.user;
            this.checkStylist();
            this.initUserDetails();
        });

        eventBus.on("reload_user_details", () => {
            if (this.user) {
                this.getStylistDetails(this.user.id);
            }
        });

        // Close navbar when clicking links
        $(document).on("click", ".navbar-collapse a", () => {
            $(".navbar-collapse").collapse("hide");
        });

        // Get support messages status
        this.getSupportMessagesStatus();

        // Sidebar collapse event
        eventBus.on("admin_sidebar_collapse", (collapse) => {
            this.sidebarCollapse = collapse;
        });
    },
    beforeUnmount() {
        // Remove listeners if needed
        eventBus.off("user_profile_loaded");
        eventBus.off("reload_user_details");
        eventBus.off("admin_sidebar_collapse");
    },
    computed: {
        adminDetails: {
            get() {
                return this.$store.state.adminDetails;
            },
            set(value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
        showClientsEditForm: {
            get() {
                return this.$store.state.showClientsEditForm;
            },
            set(value) {
                this.$store.commit("setShowClientsEditForm", value);
            },
        },
        localNotificationCount: {
            get() {
                return this.$store.state.localNotificationCount;
            },
            set(value) {
                this.$store.commit("setLocalNotificationCount", value);
            },
        },
        checkoutAppointentsCount: {
            get() {
                return this.$store.state.checkoutAppointentsCount;
            },
            set(value) {
                this.$store.commit("setCheckoutAppointentsCount", value);
            },
        },
        hasPolicyEnabled: {
            get() {
                return this.$store.state.hasPolicyEnabled;
            },
            set(value) {
                this.$store.commit("setHasPolicyEnabled", value);
            },
        },
        isSubscriptionExpired() {
            const subscription = this.adminDetails?.subscription;

            if (!subscription || !subscription.subscription_expires_on) {
                return true;
            }

            const expiresOn = new Date(
                subscription.subscription_expires_on.replace(' ', 'T')
            );

            return expiresOn < new Date();
        },
    },
    methods: {
        checkStylist() {
            if (this.user && this.user.role === "stylist") {
                this.isStylist = true;
                this.getCheckoutAppointmentsCount();
            } else {
                this.isStylist = false;
            }
        },

        initUserDetails() {
            if (this.user) {
                this.getStylistDetails(this.user.id);
            }
        },

        logOut() {
            auth.logout(true);
            this.$router.push("/");
        },

        getCheckoutAppointmentsCount() {
            if (!this.user) return;
            const data = {
                date: moment().format("YYYY-MM-DD HH:mm:ss"),
                weeks_before: 8,
                weeks_after: 1,
            };
            const query = "?" + new URLSearchParams(data).toString();
            this.$http.get(api.actions.get_checkout_appointments_count + query).then((res) => {
                this.checkoutAppointentsCount = res.data.count;
            });
        },

        getStylistDetails(id) {
            if (!id) return;
            this.$http.get(api.actions.get_stylist_details + id).then((response) => {
                const adminDetails = response.data?.details;
                if (!adminDetails) return;

                if (adminDetails.user.role === "stylist") {
                    const user = auth.state.user || JSON.parse(localStorage.getItem("user")) || {};
                    if (!user.details) user.details = {};
                    if (!user.details.subscription) user.details.subscription = {};

                    if (
                        (!adminDetails.subscription || !adminDetails.subscription.active) &&
                        this.$route.path !== "/app/subscription-payments"
                    ) {
                        user.details.subscription.active = 0;
                        localStorage.setItem("user", JSON.stringify(user));
                        this.$router.push("/app/subscription-payments");
                    } else if (adminDetails.subscription && adminDetails.subscription.active === 1) {
                        user.details.subscription.active = 1;
                        localStorage.setItem("user", JSON.stringify(user));
                    }
                }

                adminDetails.subscription_active = true;
                if (!adminDetails.group_active || (adminDetails.group_owner && adminDetails.group_active)) {
                    this.showTeam = true;
                }

                this.$store.commit("setAdminDetails", adminDetails);
                this.hasPolicyEnabled = adminDetails.policy_enabled;
                eventBus.emit("admin_details_loaded");
            });
        },

        acceptInvite(decision) {
            if (!this.adminDetails?.group_id) return;
            const data = {
                stylist_response: decision,
                group_id: this.adminDetails.group_id,
            };
            this.$http.post(api.actions.accept_invite, data).then((response) => {
                if (response.data.error === false && this.user) {
                    this.getStylistDetails(this.user.id);
                }
            });
        },

        getSupportMessagesStatus() {
            this.$http.get(api.actions.get_unread_support_messages_count).then((response) => {
                this.localNotificationCount = response.data.count;
            });
        },

        goToSupport() {
            this.localNotificationCount = 0;
            this.$router.push("/app/contact-us");
        },

        changeSidebarState() {
            this.sidebarCollapse = !this.sidebarCollapse;
            eventBus.emit("admin_sidebar_collapse", this.sidebarCollapse);
        },

        getInitial(name) {
            return name ? name[0].toUpperCase() : "";
        },

        showClientList() {
            this.showClientsEditForm = false;
        },
    },
};
</script>
